import React, { useRef } from 'react';
import { Canvas, useFrame, useThree } from '@react-three/fiber';
import { Stars, Float, Sphere } from '@react-three/drei';
import * as THREE from 'three';

function FloatingSpheres() {
  const groupRef = useRef();

  useFrame(({ clock }) => {
    groupRef.current.rotation.y = clock.getElapsedTime() * 0.05;
  });

  return (
    <group ref={groupRef}>
      {Array.from({ length: 20 }).map((_, i) => (
        <Float
          key={i}
          speed={1}
          rotationIntensity={0.4}
          floatIntensity={0.8}
          position={[
            (Math.random() - 0.5) * 25,
            (Math.random() - 0.5) * 12,
            (Math.random() - 0.5) * 40,
          ]}
        >
          <Sphere args={[0.5, 32, 32]}>
            <meshStandardMaterial
              color="#ff6600"
              emissive="rgba(0,0,0,0.3)"
              emissiveIntensity={0.6}
              roughness={0.2}
              metalness={0.3}
            />
          </Sphere>
        </Float>
      ))}
    </group>
  );
}

function ZoomingCamera() {
  const { camera } = useThree();
  const startZ = 20;
  const range = 5;

  useFrame(({ clock }) => {
    const t = clock.getElapsedTime();
    camera.position.z = startZ + Math.sin(t * 0.5) * range; // zoom in/out smoothly
  });

  return null;
}

const ParallaxBackground = () => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100vh',
        zIndex: 0,
      }}
    >
      <Canvas
        camera={{ position: [0, 0, 20], fov: 75 }}
        gl={{ antialias: true }}
        onCreated={({ scene }) => {
          scene.fog = new THREE.FogExp2('rgba(11,29,58,0.1)', 0.025);
          scene.background = new THREE.Color('#0b1d3a');
        }}
      >
        <ambientLight intensity={0.5} />
        <pointLight position={[10, 10, 10]} intensity={1.2} />
        <Stars radius={200} depth={80} count={2000} factor={5} fade />
        <FloatingSpheres />
        <ZoomingCamera />
      </Canvas>
    </div>
  );
};

export default ParallaxBackground;
